export const OddajRzeczyYellowHeader = () => {
  return (
    <section className="yellowHeader">
      <h2>Ważne!</h2>
      <p>Uzupełnij szczegóły dotyczące Twoich rzeczy. Dzięki temu będziemy wiedzieć komu najlepiej je przekazać.</p>
    </section>
  );
};
